import { SITE } from "../constants/site";

export const SEED_LINKEDIN_POSTS = [
  {
    id: "li-post-1",
    post_url: SITE.linkedin || "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
    content: "Excited to share how AdmissionsNest is transforming global university applications for 2026! \uD83C\uDF93 From shortlisting top-tier programs across the US, UK, and Europe to personalized SOP guidance and scholarship applications, our dedicated mentors walk students through every milestone.\n\nOver 80% of application stress comes from lack of a structured timeline. With our milestone tracker, students never miss a financial aid or admissions deadline.",
    tags: ["#HigherEducation", "#AdmissionsNest", "#StudyAbroad", "#CareerGuidance", "#CrescetEdustreams"],
    author_name: "Crescet Edustreams Consulting",
    author_tagline: "DPIIT-Recognized EdTech Ecosystem | AdmissionsNest · CounselNest · TutorsNest",
    author_avatar: "/crescet-favicon.png",
    media_url: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1200&q=80",
    media_type: "image",
    likes_count: 68,
    comments_count: 12,
    shares_count: 9,
    published_at: "2026-03-11T10:30:00.000Z",
  },
  {
    id: "li-post-2",
    post_url: SITE.linkedin || "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
    content: "Why guesswork fails in stream selection: When students pick Class 11 streams purely on marks or peer trends, career dissatisfaction follows.\n\nAt CounselNest, we combine scientific psychometric profiling with Dermatoglyphics Multiple Intelligence (DMIT) analysis to uncover a student's innate cognitive strengths. Our certified career counsellors then translate those data points into real-world career clarity.",
    tags: ["#CareerCounselling", "#CounselNest", "#DMIT", "#Psychometrics", "#StudentGuidance"],
    author_name: "Crescet Edustreams Consulting",
    author_tagline: "DPIIT-Recognized EdTech Ecosystem | AdmissionsNest · CounselNest · TutorsNest",
    author_avatar: "/crescet-favicon.png",
    media_url: "https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&w=1200&q=80",
    media_type: "image",
    likes_count: 94,
    comments_count: 19,
    shares_count: 14,
    published_at: "2026-03-08T14:15:00.000Z",
  },
  {
    id: "li-post-3",
    post_url: SITE.linkedin || "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
    content: "Meet AskPurple \u2014 our 24/7 AI-powered study companion and ecosystem navigator! \uD83D\uDC9C\n\nWhether a student has a late-night homework question, needs clarity on entrance exam syllabi, or wants to find the top verified career counsellor for their dream field, AskPurple provides instant, contextual answers. Powered by intelligent retrieval and backed by certified human mentors.",
    tags: ["#AskPurple", "#EdTechAI", "#StudentSuccess", "#FutureOfEducation", "#AIinEducation"],
    author_name: "Crescet Edustreams Consulting",
    author_tagline: "DPIIT-Recognized EdTech Ecosystem | AdmissionsNest · CounselNest · TutorsNest",
    author_avatar: "/crescet-favicon.png",
    media_url: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1200&q=80",
    media_type: "image",
    likes_count: 127,
    comments_count: 24,
    shares_count: 21,
    published_at: "2026-03-04T09:00:00.000Z",
  },
  {
    id: "li-post-4",
    post_url: SITE.linkedin || "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
    content: "What makes a great tutor? It's not just subject mastery \u2014 it's the empathy to diagnose learning bottlenecks and build confidence.\n\nWith TutorsNest, we are curating verified subject educators across CBSE, ICSE, Cambridge (IGCSE), IB, and competitive entrance exam boards. Every session is tracked for conceptual clarity and benchmark outcomes.",
    tags: ["#TutorsNest", "#Mentorship", "#ExamPrep", "#PersonalizedLearning", "#EducationMatters"],
    author_name: "Crescet Edustreams Consulting",
    author_tagline: "DPIIT-Recognized EdTech Ecosystem | AdmissionsNest · CounselNest · TutorsNest",
    author_avatar: "/crescet-favicon.png",
    media_url: "https://images.unsplash.com/photo-1522661067900-ab829854a57f?auto=format&fit=crop&w=1200&q=80",
    media_type: "image",
    likes_count: 53,
    comments_count: 7,
    shares_count: 6,
    published_at: "2026-02-28T11:45:00.000Z",
  },
  {
    id: "li-post-5",
    post_url: SITE.linkedin || "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
    content: "Proud Milestone: Crescet Edustreams is a DPIIT-recognized EdTech startup and ISO 9001:2015 certified organization! \uD83C\uDDEE\uD83C\uDDF3\u2728\n\nOur mission is straightforward: eliminate the fragmentation in student decision-making by uniting assessments, admissions, tutoring, and AI guidance under one trusted umbrella. Thank you to our partner institutions, counsellors, students, and parents for believing in this vision.",
    tags: ["#StartupIndia", "#DPIIT", "#QualityEducation", "#Milestone", "#EdTechIndia"],
    author_name: "Crescet Edustreams Consulting",
    author_tagline: "DPIIT-Recognized EdTech Ecosystem | AdmissionsNest · CounselNest · TutorsNest",
    author_avatar: "/crescet-favicon.png",
    media_url: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
    media_type: "image",
    likes_count: 182,
    comments_count: 31,
    shares_count: 38,
    published_at: "2026-02-20T16:20:00.000Z",
  },
];

export const linkedinService = {
  /**
   * Fetch all published LinkedIn posts.
   */
  async getPosts() {
    return SEED_LINKEDIN_POSTS;
  },
};

export default linkedinService;
